import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Building2, Home, Car, Sparkles } from 'lucide-react';
import { formatDuration } from '../../utils/format';

const SERVICE_TYPE_META = {
  salon: { label: 'Salon / Studio', icon: Building2, color: 'bg-stone-100 text-stone-700' },
  home: { label: 'Home-based', icon: Home, color: 'bg-stone-100 text-stone-700' },
  mobile: { label: 'Mobile', icon: Car, color: 'bg-amber-100 text-amber-700' }
};

export function ProviderServices({ services }) {
  return (
    <div className="mb-8">
      <h2 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-[#D4AF37]" />
        Services
      </h2>
      {services && services.length > 0 ? (
        <div className="grid sm:grid-cols-2 gap-4" data-testid="provider-services">
          {services.map((service) => (
            <Link
              key={service.service_id}
              to={`/service/${service.slug || service.service_id}`}
              className="card-surface p-5 card-hover group"
              data-testid={`provider-service-${service.service_id}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-lg font-medium text-[#1A1A1A] group-hover:text-[#D4AF37] transition-colors">
                    {service.name}
                  </h3>
                  <p className="text-stone-500 text-sm mt-1 line-clamp-2">{service.description}</p>
                </div>
                <span className="font-semibold text-[#D4AF37] text-lg whitespace-nowrap">£{service.price}</span>
              </div>
              <div className="flex items-center gap-3 mt-3 text-xs text-stone-500">
                <span className="flex items-center gap-1">
                  <Clock className="h-3.5 w-3.5" />
                  {formatDuration(service.duration)}
                </span>
                {service.service_types?.map((type) => {
                  const meta = SERVICE_TYPE_META[type];
                  if (!meta) return null;
                  const Icon = meta.icon;
                  return (
                    <span key={type} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded ${meta.color}`}>
                      <Icon className="h-3 w-3" />
                      {meta.label}
                    </span>
                  );
                })}
                {service.deposit_amount && (
                  <span className="text-[#D4AF37] font-medium">£{service.deposit_amount} deposit</span>
                )}
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="card-surface p-8 text-center">
          <p className="text-stone-500">No services listed yet.</p>
        </div>
      )}
    </div>
  );
}
